import { Box, useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { customColors } from '../../constants/theme';

interface Props {
  checked?: boolean;
  children: ReactNode;
}
const ReviewWrapper: FC<Props> = ({ checked, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: theme.spacing(1),
        mb: theme.spacing(2),
        border: `1px solid ${checked ? theme.palette.primary.main : theme.palette.divider}`,
        borderRadius: `${theme.shape.borderRadius}px`,
        backgroundColor: checked
          ? `rgba(${customColors.primary.main}, 0.1)`
          : theme.palette.background.paper,
      }}
    >
      {children}
    </Box>
  );
};

export default ReviewWrapper;
